import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPost, getPosts } from "../../actions/post.actions";
import { DateParser, isEmpty } from "../utils/Utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { S3UploadAdapterPlugin } from "./CKEditorUploadAdapter";
import parse from "html-react-parser";
import ImageProfil from "../Profil/ImageProfil";
import { getScheduledPosts } from "../../actions/scheduledPost.actions";
import { Link } from "react-router-dom";

const NewPostForm = ({ socket }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [mediaFront, setMediaFront] = useState([]); // Array of preview URLs
  const [media, setMedia] = useState([]); // Array of File objects
  const statusConfig = [
    { value: "0", label: "Par défaut" },
    { value: "1", label: "🔔 Important" },
    { value: "2", label: "✅ Résolu" },
    { value: "4", label: "🧠 Tutoriel" },
    { value: "5", label: "📄 Nouveauté" },
    { value: "6", label: "📢 Information" },
  ];
  const [status, setStatus] = useState("0");
  const [scheduledDate, setScheduledDate] = useState(null);
  const [sousTraitant, setSousTraitant] = useState(null);
  const [showScheduler, setShowScheduler] = useState(false);

  const userData = useSelector((state) => state.userReducer);
  const scheduledPosts = useSelector((state) => state.scheduledPostReducer);

  const myScheduledPosts = Object.values(scheduledPosts).filter((posts) => {
    return userData.id === posts.author;
  });

  const dispatch = useDispatch();

  const handlePicture = (e) => {
    if (e.target.files && e.target.files.length > 0) {
        const fileArray = Array.from(e.target.files);
        setMedia(prev => [...prev, ...fileArray]);
        
        const urlArray = fileArray.map(file => URL.createObjectURL(file));
        setMediaFront(prev => [...prev, ...urlArray]);
    }
  };

  const removeImage = (index) => {
      const newMedia = [...media];
      const newMediaFront = [...mediaFront];
      newMedia.splice(index, 1);
      newMediaFront.splice(index, 1);
      setMedia(newMedia);
      setMediaFront(newMediaFront);
  };

  const handlePost = async () => {
    if (!message && media.length === 0) {
      toast.error("Veuillez entrer un message ou une image");
    } else if (scheduledDate && new Date(scheduledDate) <= new Date()) {
      toast.error("La date et l'heure programmées doivent être dans le futur");
    } else {
      const data = new FormData();
      data.append("userId", userData.id);
      data.append("texte", message);
      data.append("status", status);
      
      if (media.length > 0) {
          media.forEach(file => {
              data.append("media", file);
          });
      }
      
      if (scheduledDate) data.append("scheduledDate", scheduledDate);
      if (sousTraitant) data.append("sousTraitant", sousTraitant);
      await dispatch(addPost(data))
        .then(() =>
          socket?.emit("sendNotificationAll", {
            senderName: userData.name,
          })
        )
        .then(() => cancelPost());
    }
  };

  const cancelPost = () => {
    setMessage("");
    setMediaFront([]);
    setMedia([]);
    setScheduledDate(null);
    setShowScheduler(false);
    dispatch(getPosts());
  };

  useEffect(() => {
    if (!isEmpty(userData)) setIsLoading(false);
  }, [userData]);

  useEffect(() => {
    dispatch(getScheduledPosts(10));
  }, [dispatch]);

  return (
    <>
      <div className="post-container">
        <ToastContainer />
        {isLoading ? (
          <div className="chargement">
            <i className="fas fa-spinner fa-spin"></i>
            <span>CHARGEMENT</span>
          </div>
        ) : (
          <div className="post-container-inside">
            <div className="post-container-post">
              <div className="left-post-bloc">
                <div className="user-profil">
                  <ImageProfil id={userData.id} />
                </div>
              </div>
              <div className="right-bloc">
                <div className="post-form">
                  <CKEditor
                    editor={Editor}
                    data={"Quoi de neuf, " + userData.firstname + " ?"}
                    config={{
                      extraPlugins: [S3UploadAdapterPlugin],
                      link: {
                        defaultProtocol: 'https://',
                        decorators: {
                          openInNewTab: {
                            mode: 'automatic',
                            callback: url => true,
                            attributes: {
                              target: '_blank',
                              rel: 'noopener noreferrer'
                            }
                          }
                        }
                      },
                      image: {
                        toolbar: [
                          "imageStyle:block",
                          "imageStyle:side",
                          "|",
                          "imageResize",
                          "|",
                          "toggleImageCaption",
                          "imageTextAlternative",
                        ],
                        insert: { type: "block" },
                        resizeUnit: "%",
                        resizeOptions: [
                          { name: "imageResize:original", value: null, label: "Originale" },
                          { name: "imageResize:25", value: "25", label: "25%" },
                          { name: "imageResize:50", value: "50", label: "50%" },
                          { name: "imageResize:75", value: "75", label: "75%" },
                        ],
                      }
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setMessage(data);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Toolbar */}
            <div className="post-toolbar">
              <div className="toolbar-left">
                <label className="toolbar-btn" htmlFor="file-upload" title="Ajouter des images">
                  <i className="far fa-image"></i>
                  <span>Photo</span>
                  <input
                    type="file"
                    id="file-upload"
                    name="media"
                    multiple
                    accept=".jpg, .jpeg, .png"
                    onChange={(e) => handlePicture(e)}
                  />
                </label>

                <div className="toolbar-btn toolbar-select-wrapper">
                  <i className="fas fa-tag"></i>
                  <select
                    className="toolbar-select"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    {statusConfig.map((s) => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </select>
                </div>

                <button
                  type="button"
                  className={`toolbar-btn ${scheduledDate ? "toolbar-btn-active" : ""}`}
                  title="Programmer le post"
                  onClick={() => setShowScheduler(!showScheduler)}
                >
                  <i className="far fa-clock"></i>
                  <span>{scheduledDate ? scheduledDate.replace("T", " ") : "Programmer"}</span>
                </button>

                <div className="toolbar-sep" />

                <label
                  className="toolbar-switch"
                  title="Envoyer par mail au sous-traitant"
                >
                  <i className="fas fa-users"></i>
                  <span>Sous-traitant</span>
                  <input
                    type="checkbox"
                    onChange={(e) => setSousTraitant(e.target.checked)}
                  />
                  <div className="switch-track"></div>
                </label>
              </div>

              <div className="toolbar-right">
                {(message || mediaFront.length > 0) && (
                  <button className="toolbar-cancel" onClick={cancelPost}>
                    Annuler
                  </button>
                )}
                <button className="toolbar-post-btn" onClick={handlePost}>
                  <i className="fas fa-paper-plane"></i>
                  Publier
                </button>
              </div>
            </div>

            {/* Scheduler picker */}
            {showScheduler && (
              <div className="scheduler-picker">
                <div className="scheduler-header">
                  <i className="far fa-clock"></i>
                  <span>Programmer la publication</span>
                  <button
                    type="button"
                    className="scheduler-close"
                    onClick={() => setShowScheduler(false)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <div className="scheduler-body">
                  <label className="scheduler-label">Date et heure</label>
                  <input
                    type="datetime-local"
                    value={scheduledDate || ""}
                    onChange={(e) => setScheduledDate(e.target.value)}
                  />
                </div>
                {scheduledDate && (
                  <div className="scheduler-footer">
                    <span className="scheduler-info">
                      <i className="fas fa-check-circle"></i>
                      Sera publié le {new Date(scheduledDate).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })} à {new Date(scheduledDate).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}
                    </span>
                    <button
                      type="button"
                      className="scheduler-clear"
                      onClick={() => { setScheduledDate(null); setShowScheduler(false); }}
                    >
                      Retirer
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Image previews */}
            {mediaFront.length > 0 && (
              <div className="post-media-preview">
                {mediaFront.map((url, idx) => (
                  <div key={idx} className="media-thumb">
                    <img src={url} alt="preview" />
                    <button className="media-thumb-remove" onClick={() => removeImage(idx)}>
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Preview */}
            {(message || mediaFront.length > 0) ? (
              <div className="preview-container">
                <div className="preview-left-header">
                  <ImageProfil id={userData.id} />
                  <div className="preview-user-info">
                    <span className="name">
                      {userData.firstname + " " + userData.name}
                    </span>
                    <span className="service">{userData.service}</span>
                    <span className="date">
                      {DateParser(new Date(Date.now()))}
                    </span>
                  </div>
                </div>
                <div className="preview-content">
                  <div>{parse(message)}</div>
                  {mediaFront.length > 0 && (
                    <div className="preview-images">
                      {mediaFront.map((url, idx) => (
                        <img key={idx} src={url} alt="preview" />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
      {myScheduledPosts.length > 0 ? (
        <div className="scheduled-post">
          {myScheduledPosts.map((post) => (
            <div className="scheduled-content" key={post.id}>
              <Link to={`/post/${post.id}`}>
                <i className="far fa-clock"></i> Vous avez un message programmé
                à la date du : {DateParser(post.scheduledDate)}
              </Link>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default NewPostForm;
